var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[_c('el-avatar',{staticClass:"avatar__photo",attrs:{"size":30,"src":_vm.photo}}),_c('div',{staticClass:"avatar__name"},[_vm._v(_vm._s(_vm.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }